/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { useState, useContext } from 'react';
import { LinkButton } from '@blend/enterprise-components';

import { ConfigContext } from 'id-components/ConfigContext/ConfigContext';
import {
  SettlementAgentTermsAndConditionsModal,
  GeneralTermsAndConditionsModal,
  SettlementAgentTermsAndConditionsModal2026,
  GeneralTermsAndConditionsModal2026,
} from 'id-components/TermsAndConditionsModal';
import {
  SettlementAgentPrivacyPolicyModal,
  GeneralPrivacyPolicyModal,
  SettlementAgentPrivacyPolicyModal2026,
  GeneralPrivacyPolicyModal2026,
} from 'id-components/PrivacyPolicyModal';

export namespace ComplianceInputLabel {
  export interface Props {}
}

export const ComplianceInputLabel: React.FC<ComplianceInputLabel.Props> = () => {
  const config = useContext(ConfigContext);

  const [areSettlementAgentTermsAndConditionsOpen, setSettlementAgentTermsAndConditionsOpen] = useState<boolean>(false);
  const [areGeneralTermsAndConditionsOpen, setGeneralTermsAndConditionsOpen] = useState<boolean>(false);
  const [isSettlementAgentPrivacyPolicyOpen, setSettlementAgentPrivacyPolicyOpen] = useState<boolean>(false);
  const [isGeneralPrivacyPolicyOpen, setGeneralPrivacyPolicyOpen] = useState<boolean>(false);

  const SettlementAgentTermsOfUse = () => (
    <LinkButton
      btnSize="sm"
      id="it-SettlementAgentTermsAndConditions"
      inline
      label="Terms of Use"
      onClick={() => setSettlementAgentTermsAndConditionsOpen(true)}
    />
  );

  const GeneralTermsOfUse = () => (
    <LinkButton
      btnSize="sm"
      id="it-GeneralTermsAndConditions"
      inline
      label="Terms of Use"
      onClick={() => setGeneralTermsAndConditionsOpen(true)}
    />
  );

  const GeneralPrivacyPolicy = () => (
    <LinkButton
      btnSize="sm"
      id="it-GeneralPrivacyPolicy"
      inline
      label="Privacy Policy"
      onClick={() => setGeneralPrivacyPolicyOpen(true)}
    />
  );

  const SettlementAgentPrivacyPolicy = () => (
    <LinkButton
      btnSize="sm"
      id="it-SettlementAgentPrivacyPolicy"
      inline
      label="Privacy Policy"
      onClick={() => setSettlementAgentPrivacyPolicyOpen(true)}
    />
  );

  const Terms = () => {
    if (
      config?.featureFlags?.identityGeneralTerms20240617 ||
      config?.featureFlags?.identityGeneralTermsMultiTenant20240617
    ) {
      return (
        <>
          I confirm that I have read and agree to the <SettlementAgentTermsOfUse /> and <SettlementAgentPrivacyPolicy />{' '}
          for Settlement Agents or the <GeneralTermsOfUse /> and <GeneralPrivacyPolicy /> for all other users.
        </>
      );
    } else {
      return (
        <>
          I confirm that I have read and agree to the <SettlementAgentTermsOfUse /> and <SettlementAgentPrivacyPolicy />
          .
        </>
      );
    }
  };

  const use2026Version =
    config?.featureFlags?.enable2026SettlementAgentWorkspacePrivacyPolicyAndTermsOfUse20260107 ||
    config?.featureFlags?.enable2026SettlementAgentWorkspacePrivacyPolicyAndTermsOfUseMultiTenant20260107;

  return (
    <span>
      <Terms />
      {use2026Version ? (
        <>
          <GeneralTermsAndConditionsModal2026
            btnLabel="Done"
            handleClose={() => setGeneralTermsAndConditionsOpen(false)}
            isOpen={areGeneralTermsAndConditionsOpen}
          />
          <SettlementAgentTermsAndConditionsModal2026
            btnLabel="Done"
            handleClose={() => setSettlementAgentTermsAndConditionsOpen(false)}
            isOpen={areSettlementAgentTermsAndConditionsOpen}
          />
          <GeneralPrivacyPolicyModal2026
            handleClose={() => setGeneralPrivacyPolicyOpen(false)}
            isOpen={isGeneralPrivacyPolicyOpen}
          />
          <SettlementAgentPrivacyPolicyModal2026
            handleClose={() => setSettlementAgentPrivacyPolicyOpen(false)}
            isOpen={isSettlementAgentPrivacyPolicyOpen}
          />
        </>
      ) : (
        <>
          <GeneralTermsAndConditionsModal
            btnLabel="Done"
            handleClose={() => setGeneralTermsAndConditionsOpen(false)}
            isOpen={areGeneralTermsAndConditionsOpen}
          />
          <SettlementAgentTermsAndConditionsModal
            btnLabel="Done"
            handleClose={() => setSettlementAgentTermsAndConditionsOpen(false)}
            isOpen={areSettlementAgentTermsAndConditionsOpen}
          />
          <GeneralPrivacyPolicyModal
            handleClose={() => setGeneralPrivacyPolicyOpen(false)}
            isOpen={isGeneralPrivacyPolicyOpen}
          />
          <SettlementAgentPrivacyPolicyModal
            handleClose={() => setSettlementAgentPrivacyPolicyOpen(false)}
            isOpen={isSettlementAgentPrivacyPolicyOpen}
          />
        </>
      )}
    </span>
  );
};
